import React from "react";
import { MapPinIcon } from "@heroicons/react/24/solid";

export default function Pin() {
  return (
    <div
      style={{
        position: "absolute",
        transform: "translate(-50%, -100%)",
        pointerEvents: "none",
      }}
    >
      <MapPinIcon style={{ width: 36, height: 36, color: "#EA4236" }} />
    </div>
  );
}
